import styled from '@emotion/styled'
import { baseLayout } from '../../constants/theme'

export const Footer = styled('div')(({ collapsed, theme, isAssistino }) => ({
  position: isAssistino ? 'fixed' : 'absolute',
  bottom: isAssistino ? 0 : 'auto',
  zIndex: isAssistino ? 1000 : 'auto',
  left: collapsed
    ? `${baseLayout.sidebarCollapsedWidth} !important`
    : baseLayout.sidebarWidth,
  padding: `calc(${baseLayout.gridGutterWidth} / 2)`,
  right: '0',
  color: baseLayout.brandColorOrange,
  height: baseLayout.footerHeight, // `calc(${theme.footerHeight} - 20px)`,
  backgroundColor: theme.footerBg,
  textAlign: 'center',
  fontSize: '0.8125rem',
  '@media (max-width: 991.98px)': {
    left: collapsed
      ? '0  !important'
      : `${baseLayout.sidebarCollapsedWidth} !important`,
  },
  '@media print': {
    display: 'none !important',
  },
}))

export const FooterContent = styled('span')(({ theme }) => ({
  color: theme.footerSpanColor,
}))
